const parseToNumber = (str: string): number => {
  return parseFloat(str.split(',').join(''));
};

export default parseToNumber;
